"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.setTokens = exports.writeTokensToCookies = exports.writeTokensToLocalStorage = void 0;

var _clientStorage = require("../../constants/clientStorage");

var _clientStorage2 = require("../clientStorage");
/**
 * writes auth tokens to localStorage
 */


var writeTokensToLocalStorage = function writeTokensToLocalStorage(tokens) {
  var accessToken = tokens.accessToken,
      idToken = tokens.idToken;
  (0, _clientStorage2.setItem)('accessToken', accessToken, _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE);
  (0, _clientStorage2.setItem)('idToken', idToken, _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE);
};
/**
 * writes auth tokens to cookies
 */


exports.writeTokensToLocalStorage = writeTokensToLocalStorage;

var writeTokensToCookies = function writeTokensToCookies(tokens) {
  var accessToken = tokens.accessToken,
      idToken = tokens.idToken;
  (0, _clientStorage2.setItem)('accessToken', accessToken, _clientStorage.CLIENT_STORAGE_COOKIES);
  (0, _clientStorage2.setItem)('idToken', idToken, _clientStorage.CLIENT_STORAGE_COOKIES);
};
/**
 * Write tokens to all supported storage types
 */


exports.writeTokensToCookies = writeTokensToCookies;

var writeTokensToAll = function writeTokensToAll(tokens) {
  // write the tokens to local storage
  writeTokensToLocalStorage(tokens); // write the tokens to cookies

  writeTokensToCookies(tokens);
};

var setTokens = function setTokens(tokens, clientStorageType) {
  switch (clientStorageType) {
    case _clientStorage.CLIENT_STORAGE_COOKIES:
      return writeTokensToCookies(tokens);

    case _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE:
      return writeTokensToLocalStorage(tokens);

    case _clientStorage.CLIENT_STORAGE_ALL:
    default:
      return writeTokensToAll(tokens);
  }
};

exports.setTokens = setTokens;
var _default = setTokens;
exports.default = _default;